module.exports = __webpack_public_path__ + "img/noData.1649002c.png";